export const subarraBorderData: number[][] = [
  [-900, 1000],
  [-900, 900],
  [-950, 800],
  [-1000, 700],
  [-1100, 600],
  [-1000, 500],
  [-1000, 300],
  [-1000, 0],
  [-1000, -200],
  [-1100, -100],
  [-1150, 0],
  [-1150, 100],
  [-1250, 200],
  [-1350, 280],
  [-1400, 300],
  [-1500, 400],
  [-1500, 500],
  [-1570, 600],
  [-1650, 700],
  [-1700, 800],
  [-1760, 900],
  [-1840, 1000],
  [-1870, 1100],
  [-1840, 1200],
  [-1800, 1300],
  [-1780, 1400],
  [-1760, 1500],
  [-1760, 1600],
  [-1760, 1700],
  [-1700, 1800],
  [-1670, 1900],
  [-1650, 2000],
  [-1600, 2100],
  [-1500, 2150],
  [-1400, 2200],
  [-1300, 2300],
  [-1200, 2500],
  [-1150, 2700],
  [-1150, 2900],
  [-1150, 3100],
  [-950, 3200],
  [-750, 2900],
  [-750, 2700],
  [-750, 2500],
  [-750, 2300],
  [-800, 2100],
  [-800, 1900],
  [-750, 1700],
  [-850, 1500],
  [-850, 1300],
  [-850, 1200],
  [-900, 1100],
  [-900, 1000],
];
